// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gliscor: PokeData = {
  "id": 472,
  "name": "gliscor",
  "height": 20,
  "weight": 425,
  "base_experience": 179,
  "types": [
    PokeType.GROUND,
    PokeType.FLYING
  ],
  "api_moves": [
    "guillotine",
    "swords-dance",
    "sand-attack",
    "poison-sting",
    "pin-missile",
    "earthquake",
    "quick-attack",
    "screech",
    "harden",
    "crabhammer",
    "slash",
    "feint-attack",
    "mud-slap",
    "fury-cutter",
    "knock-off",
    "sky-uppercut",
    "aerial-ace",
    "u-turn",
    "poison-jab",
    "night-slash",
    "x-scissor",
    "earth-power",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "acrobatics"
  ],
  "moves": [
    "pin-missile",
    "earthquake",
    "quick-attack",
    "mud-slap",
    "aerial-ace",
    "poison-jab",
    "night-slash",
    "earth-power",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "mud-bomb",
    "acrobatics"
  ],
  "evolution_chain": {
    "id": 104,
    "item": null,
    "species": [
      {
        "name": "gligar",
        "order": 238,
        "types": [
          PokeType.GROUND,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gliscor",
        "order": 239,
        "types": [
          PokeType.GROUND,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 207,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 137,
    "ability_power": 137
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
